import React, { Component } from 'react'
import download from 'downloadjs'
import PropTypes from 'prop-types'

import { FieldLabel } from 't3-widgets'

import { getActivatedUnitsHistory, getTooltip } from '../../common/operations'

import styles from './activated-units-history.module.css'

class ActivatedUnitsHistory extends Component {
    constructor(props, context) {
        super(props, context)
        this.openActivationHistoryReport = this.openActivationHistoryReport.bind(this)
    }

    render() {
        const { intl } = this.props

        return (
            <div className={styles['link-dwn']}>
                <a className={styles['link']} onClick={this.openActivationHistoryReport}>
                    {intl.translate('ap_step2_history_label')}
                </a>
                <FieldLabel tooltip={getTooltip('', intl.translate('ap_step2_history_label_hint'))} />
            </div>
        )
    }

    openActivationHistoryReport() {
        const { activationCode, customerNumber } = this.props
        getActivatedUnitsHistory(activationCode, customerNumber).then(response => {
            const fileName = response.headers['x-file-name']
            download(new Blob([response.data], { type: 'text/csv' }), fileName, 'text/csv')
        })
    }
}

ActivatedUnitsHistory.propTypes = {
    activationCode: PropTypes.string.isRequired,
    customerNumber: PropTypes.string.isRequired,
    intl: PropTypes.objectOf(PropTypes.func)
}

ActivatedUnitsHistory.defaultProps = {
    activationCode: '',
    customerNumber: ''
}

export { ActivatedUnitsHistory }
